import { AuthLoadingActions, AuthState } from './auth';
import { CartLoadingActions, CartState } from './cart';
import { DownloadsLoadingActions, DownloadsState } from './downloads';
import { DreamboxLoadingActions, DreamboxState } from './dreambox';
import { GalleryLoadingActions, GalleryState } from './gallery';
import { ImageLoadingActions, ImageState } from './image';
import { InvoicesLoadingActions, InvoicesState } from './invoices';
import { ListingsLoadingActions, ListingsState } from './listings';
import { MainpageLoadingActions, MainpageState } from './mainpage';
import { ProfileLoadingActions, ProfileState } from './profile';

export * from './auth';
export * from './cart';
export * from './downloads';
export * from './gallery';
export * from './dreambox';
export * from './image';
export * from './invoices';
export * from './listings';
export * from './mainpage';
export * from './profile';
export * from './router';

export const AppState = [
  AuthState,
  ImageState,
  GalleryState,
  DreamboxState,
  MainpageState,
  ListingsState,
  ProfileState,
  CartState,
  DownloadsState,
  InvoicesState,
];

export const LoadingActions = [
  ...AuthLoadingActions,
  ...ImageLoadingActions,
  ...GalleryLoadingActions,
  ...DreamboxLoadingActions,
  ...MainpageLoadingActions,
  ...ListingsLoadingActions,
  ...ProfileLoadingActions,
  ...CartLoadingActions,
  ...DownloadsLoadingActions,
  ...InvoicesLoadingActions,
];
